import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initPartnersSlider = () => {
  const slider = document.querySelector(".partners-slider");

  slider && new Swiper(slider, {
    loop: true,
    lazy: true,
    slidesPerView: 1,
    autoHeight: true,
    navigation: {
      nextEl: ".partners .slider-navigation__button--next",
      prevEl: ".partners .slider-navigation__button--prev",
    },
    pagination: {
      el: ".partners .partners-pagination",
      bulletActiveClass: "active",
      clickable: true,
    },
  });
};

export default initPartnersSlider;
